import { render, staticRenderFns } from "./todoTask.vue?vue&type=template&id=1d459b02&scoped=true&"
import script from "./todoTask.vue?vue&type=script&lang=js&"
export * from "./todoTask.vue?vue&type=script&lang=js&"
import style0 from "./todoTask.vue?vue&type=style&index=0&id=1d459b02&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d459b02",
  null
  
)

export default component.exports